module.exports = __webpack_public_path__ + "img/1482328596.888d9f06.jpg";